import React, { Component } from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import "./../../View.css";
import "./../../Grid.css";
import "./../../Form.css";
import "./../../App.css";
import UnitStandardsTable from '../UnitStandardsTable';
import EnhancedToolbar from '../../widgets/Toolbar';
import QCTOModuleSetupSearch from '../program/QCTOModule/QCTOModuleSetupSearch';
import LinkDialog from "../LinkDialog";
import ViewUtils from "./../../ViewUtils";
import { ViewContainer } from "./../../View.jsx";
import Prompt from '../../widgets/Prompt';
import AlertItem from "../../widgets/AlertItem";


const utils = new ViewUtils();

const headCells = [
    { id: 'ModuleCode', numeric: false, disablePadding: true, label: 'Module Code' },
    { id: 'ModuleTitle', numeric: false, disablePadding: true, label: 'Module Title' },
    { id: 'Credits', numeric: false, disablePadding: true, label: 'Credits' },
    { id: 'LearningType', numeric: false, disablePadding: true, label: 'Learning Type' },
    { id: 'NQFLevel', numeric: false, disablePadding: true, label: 'NQF Level' }
];

const toolbarRef = React.createRef();

class SDProviderQCTOQualificationModule extends Component {

    constructor(props) {
        super(props);

        this.state = {
            linkDialogOpen: false,
            selectedLinkType: null,
            selectedLinkStandards: null,
            selectedUnitStandard: null,
            keyUpSwitch: false,
            propmtOpen: false,
            promptTitle: "Unlink Module From the Skills Development Providers QCTO Qualification",
            promptContent: "Are you sure you want to unlink this module from the providers Skills Development Providers QCTO Qualification?",
            message: "",
            messageStyle: "",
            searchParameters: [
                { Name: "ProviderQualificationID", Value: this.props.location.state.ProviderQualificationID },
                { Name: "SkillsDevelopmentProviderID", Value: this.props.location.state.SkillsDevelopmentProviderID }
            ]
           
        }

        this.toolbarConfig = {
            items: [
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'close', label: 'CLOSE', tooltip: 'Close', icon: 'CloseIcon' }
                    ]
                },
                {
                    type: "devider"
                },
                {
                    type: "buttonGroup",
                    buttons: [
                        {
                            contextMenu: [
                                { id: 1, description: "Elective" }
                            ],
                            id: 'link', label: 'Link', tooltip: 'link the selected module to the Skills Development Providers QCTO Qualification', width: "60px"
                        },
                        { id: 'link', label: '', contextIcon: 'LinkIcon', tooltip: 'Link module/s to the Skills Development Providers QCTO Qualification'},
                        { id: 'unlink', label: '', icon: 'LinkOffIcon', tooltip: 'Un-link the selected module from the Skills Development Providers QCTO Qualification', disabled: utils.isNull(this.state.selectedUnitStandard) }
                    ]
                }
            ]
        };
    }

    handleToolbarButtonClick(buttonId) {
        if ("close" === buttonId) {
            this.props.history.push({
                pathname: '/SDProviderQCTOQualificationsSearch',
                state: {
                    selection: this.props.location.state.SkillsDevelopmentProviderID,
                    providerName: this.props.location.state.providerName,
                    providerSDLNumber: this.props.location.state.providerSDLNumber
                }
            });
        } else if ("unlink" === buttonId) {
            this.setState({ promptOpen: true })
        }
    }

    successCallback = (response) => {
        if (!utils.isNull(response.EntityId) && response.EntityId === 0) {
            this.setState({
                selectedUnitStandard: null,
                selectedLinkType: null,
                selectedLinkStandards: null,
                selectedUnitStandard: null,
                message: response.Message,
                messageStyle: response.MessageType.toLowerCase()
            })
            this.setState({ searchParameters: JSON.parse(JSON.stringify(this.state.searchParameters)) })
        }
        else if (!utils.isNull(response.Message) && response.Message !== "") {
            this.setState({
                message: response.Message,
                messageStyle: response.MessageType.toLowerCase()
            })
        }
    }


    unlinkUnitstandard(url) {
        this.setState({ promptOpen: false }, () => {
            toolbarRef.current.setButtonDisabled("unlink", true);
        })

        let fullUrl = `${url}?id=${this.state.selectedUnitStandard}&ProviderQualificationID=${this.props.location.state.ProviderQualificationID}`
        utils.invokeUrlDelete(fullUrl, this.successCallback, null);
    }

    handleToolbarButtonMenuClick(menu) {
        this.setState({ linkDialogOpen: true, selectedLinkType: menu });
    }

    postLinkHandler(isCancel, linked) {
        if (linked === true) {
            this.setState({
                searchParameters: JSON.parse(JSON.stringify(this.state.searchParameters)),
                linkDialogOpen: false, selectedUnitStandard: null
            });
        }
        else if (isCancel === true) {
            this.setState({
                linkDialogOpen: false
            })
        }
    }

    handleSelectionChange = (selection) => {
        if (selection !== null && selection.length !== 0) {
            this.setState({
                selectedUnitStandard: selection[0].Id,
                message: "",
                messageStyle: ""
            });
        }
        else {
            this.setState({
                selectedUnitStandard: null,
                message: "",
                messageStyle: ""
            });
        }
        toolbarRef.current.setButtonDisabled("unlink", selection === null || selection.length === 0);
    }

    closePrompt = () => {
        this.setState({ propmtOpen: false })
    }

    render() {
        return (
            <ViewContainer>
                <p className="breadcrumbs">
                    {"Skills Development Providers QCTO Qualification Modules"}
                </p>
                <AlertItem message={this.state.message} alertStyle={this.state.messageStyle} />
                <div className="searchResults">
                    <EnhancedToolbar highlight={false}
                        ref={toolbarRef}
                        buttonClickHandler={(buttonId) => this.handleToolbarButtonClick(buttonId)}
                        buttonMenuClickHandler={(menu) => this.handleToolbarButtonMenuClick(menu)}
                        config={this.toolbarConfig} />
                    <UnitStandardsTable headCells={headCells} onSelectionChange={(selection) => { this.handleSelectionChange(selection) }}
                        dataUrl="api/sims/skillsdevelopmentproviderqualification/GetProviderQCTOQualificationModuleSearch"
                        height={"50vh"}
                        searchParameters={this.state.searchParameters} paged={false} />
                </div>

                <LinkDialog open={this.state.linkDialogOpen} type={this.state.selectedLinkType}
                    title={this.props.location.state.QualificationTitle}
                    closeHandler={(isCancelled, linked) => this.postLinkHandler(isCancelled, linked)}
                    dialogTitle={`Link Modules to the Skills Development Providers QCTO Qualification: ${this.props.location.state.QualificationTitle}`}
                    linkName={"Modules"} postUrl={"api/sims/skillsdevelopmentproviderqualification/linkQCTOQualificationModules"} usePost={true}
                    programmeId={this.props.location.state.ProviderQualificationID} 
                >
                    <QCTOModuleSetupSearch dataUrl="api/sims/skillsdevelopmentproviderqualification/GetSearchLinkableQCTOQualificationModules"
                        multiSelect={true} showTitle={false}
                        programmeId={this.props.location.state.ProviderQualificationID} 
                        mode="lookup"
                    />
                </LinkDialog>

                <Prompt open={this.state.promptOpen}
                    promptTitle={this.state.promptTitle}
                    promptContent={this.state.promptContent}
                    handleYes={() => this.unlinkUnitstandard(`api/sims/skillsdevelopmentproviderqualification/unlinkproviderqctoqualificationModule`)}
                    closePrompt={this.closePrompt}
                />
            </ViewContainer>

        );
    }
}

export default withRouter(
    connect()(SDProviderQCTOQualificationModule)
);
